import { render, staticRenderFns } from "./SolutionStatCard.vue?vue&type=template&id=af687db4&scoped=true&"
var script = {}
import style0 from "./SolutionStatCard.vue?vue&type=style&index=0&id=af687db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af687db4",
  null
  
)

export default component.exports